export default __webpack_public_path__ + "static/media/11-65.1f9db604.png";